import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  getAdminHomeworkMasters,
  getAdminHomeworkMasterById,
  createAdminHomeworkMaster,
  updateAdminHomeworkMaster,
  deleteAdminHomeworkMaster,
} from "../../api/admin/homeworkMaster.api";

/* ============================================================
   FETCH HOMEWORK MASTER LIST (PAGINATED & SEARCHABLE)
============================================================ */

export const fetchHomeworkMasters = createAsyncThunk(
  "admin/homeworkMaster/fetch",
  async (
    { page = 1, limit = 10, search = "" } = {},
    { rejectWithValue }
  ) => {
    try {
      const res = await getAdminHomeworkMasters({
        page,
        limit,
        search,
      });

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error.message || "Failed to fetch Homework Records."
      );
    }
  }
);

/* ============================================================
   FETCH SINGLE HOMEWORK MODEL WITH ROSTER STATES
============================================================ */

export const fetchHomeworkMasterById = createAsyncThunk(
  "admin/homeworkMaster/fetchById",
  async (id, { rejectWithValue }) => {
    try {
      const res = await getAdminHomeworkMasterById(id);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res.data;
    } catch (error) {
      return rejectWithValue(
        error.message || "Failed to fetch Homework Master details."
      );
    }
  }
);

/* ============================================================
   CREATE & DISTRIBUTE HOMEWORK (GROUP OR INDIVIDUAL SCOPE)
============================================================ */

export const addHomeworkMaster = createAsyncThunk(
  "admin/homeworkMaster/add",
  async (payload, { rejectWithValue }) => {
    try {
      console.log(
        "📡 ADD HOMEWORK MASTER PAYLOAD:",
        payload
      );

      const res = await createAdminHomeworkMaster(payload);

      console.log(
        "📥 ADD HOMEWORK MASTER RESPONSE:",
        res
      );

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res;

    } catch (error) {

      return rejectWithValue(
        error.message || "Failed to assign and create Homework."
      );

    }
  }
);

/* ============================================================
   UPDATE HOMEWORK DEFINITIONS & DEADLINES
============================================================ */

export const updateHomeworkMaster = createAsyncThunk(
  "admin/homeworkMaster/update",
  async (
    {
      id,
      homeworkMasterData,
    },
    { rejectWithValue }
  ) => {
    try {
      const res = await updateAdminHomeworkMaster(
        id,
        homeworkMasterData
      );

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res;

    } catch (error) {

      return rejectWithValue(
        error.message || "Failed to update Homework definitions."
      );

    }
  }
);

/* ============================================================
   DELETE HOMEWORK MASTER (CASCADE SAFE CLEAR)
============================================================ */

export const deleteHomeworkMaster = createAsyncThunk(
  "admin/homeworkMaster/delete",
  async (
    id,
    { rejectWithValue }
  ) => {
    try {
      const res = await deleteAdminHomeworkMaster(id);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return {
        id,
        message: res.message,
      };

    } catch (error) {

      return rejectWithValue(
        error.message || "Failed to remove Homework footprints."
      );

    }
  }
);